import {
  AgentQueryCancelledResponse,
  IAgentConversationDataModel,
  IAgentMessageDataModel,
  IChatMessage,
  ICreateConversationRequest,
  MessageFeedback,
} from '../../schemas/agent-conversation.schema';
import { AgentHealthStatusValues } from '../../schemas/agent-health.schema';
import { MaggieHttp } from '../MaggieHttp';

export async function createAgentConversation(
  params: ICreateConversationRequest
): Promise<IAgentConversationDataModel> {
  const { data } = await MaggieHttp.agent.post<ICreateConversationRequest, IAgentConversationDataModel>(
    '/api/v1/conversations',
    params
  );
  return data;
}

export async function getAgentConversation(conversationId: number): Promise<IAgentConversationDataModel> {
  const { data } = await MaggieHttp.agent.get<IAgentConversationDataModel>(
    `/api/v1/conversations/${conversationId}`
  );
  return data;
}

export async function getConversationMessages(
  conversationId: number,
  limit = 200
): Promise<IAgentMessageDataModel[]> {
  const { data } = await MaggieHttp.agent.get<IAgentMessageDataModel[]>(
    `/api/v1/conversations/${conversationId}/messages`,
    {
      params: {
        limit,
      },
    }
  );
  return data;
}

export async function getAllAgentConversations(): Promise<IAgentConversationDataModel[]> {
  const { data } = await MaggieHttp.agent.get<IAgentConversationDataModel[]>('/api/v1/conversations');

  return data;
}

export async function deleteAgentConversation(conversationId: number): Promise<void> {
  await MaggieHttp.agent.delete(`/api/v1/conversations/${conversationId}`);
}

export async function sendChatMessage(message: IChatMessage): Promise<IAgentMessageDataModel> {
  const { data } = await MaggieHttp.agent.post<IChatMessage, IAgentMessageDataModel>(`/api/v1/chat`, message);

  return data;
}

export async function getMessagesForConversation(
  conversationId: number
): Promise<IAgentConversationDataModel> {
  const { data } = await MaggieHttp.agent.get<IAgentConversationDataModel>(
    `/api/v1/conversations/${conversationId}/messages`
  );
  return data;
}

export async function getHealthCheck() {
  const { data } = await MaggieHttp.agent.get<AgentHealthStatusValues>('/api/v1/health');
  return data;
}

export async function cancelAgentQuery(conversationId: number): Promise<AgentQueryCancelledResponse> {
  const { data } = await MaggieHttp.agent.post<void, AgentQueryCancelledResponse>(
    `/api/v1/conversations/${conversationId}/cancel`
  );
  return data;
}

export async function submitMessageFeedback(
  messageId: number,
  feedback: MessageFeedback
): Promise<IAgentMessageDataModel> {
  const { data } = await MaggieHttp.agent.post<{ feedback: MessageFeedback }, IAgentMessageDataModel>(
    `/api/v1/messages/${messageId}/feedback`,
    { feedback }
  );
  return data;
}
